export const taskBgColor = {
  "today": "#28c2381a",
  "yesterday": "#2555ef1a",
  "earlier": "#fa33721a",
  "todo": "#ff800a1a",
}

export const taskTextColor = {
  "today": "#28c238",
  "yesterday": "#2555ef",
  "earlier": "#fa3372",
  "todo": "#ff800a",
}